import { render, staticRenderFns } from "./CustomerMealListPage.vue?vue&type=template&id=72c1bbf4&"
import script from "./CustomerMealListPage.vue?vue&type=script&lang=js&"
export * from "./CustomerMealListPage.vue?vue&type=script&lang=js&"
import style0 from "./CustomerMealListPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports